import { useQuery } from '@tanstack/react-query'

import axios from '@shared/utils/axios'

export function useRestFetch({ key, endpoint, config, ...rest }) {
    const query = useQuery({
        queryKey: key,
        queryFn: async () => (await axios.get(endpoint, config)).data,
        ...rest
    })

    return query
}